import { Routes } from '@angular/router';
import { indexRoutes } from './features/index/index.routes';
import { LoginComponent } from './features/login/login.component';
import { RegisterComponent } from './features/register/register.component';
import { RecoveryPasswordComponent } from './features/recovery-password/recovery-password.component';
import { ChangePasswordComponent } from './features/change-password/change-password.component';
import { VerifyAccountComponent } from './features/verify-account/verify-account.component';
import { publicGuard } from './core/guards/public.guard';


export const routes: Routes = [
  {
    path: 'auth/login',
    component: LoginComponent,
    canActivate: [publicGuard]
  }, {
    path: 'auth/register',
    component: RegisterComponent,
    canActivate: [publicGuard]
  },
  {
    path: 'auth/recovery-password',
    component: RecoveryPasswordComponent,
   
  },
  {
    path: 'auth/change-password',
    component: ChangePasswordComponent
  },
  {
    path: 'auth/verified-account',
    component: VerifyAccountComponent
  },
  {
    path: '',
    children: indexRoutes
  },
  {
    path: '**',
    redirectTo: ''
  }
];
